import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

export default function ExpenseSection({ data, onChange, isOpen, onOpen }) {
  const [collapsed, setCollapsed] = useState(false);

  const ownsHome = data.ownsHome === 'yes';
  const ownsVehicle =
    (Array.isArray(data.vehicles) && data.vehicles.length > 0) ||
    (Array.isArray(data.spouseVehicles) && data.spouseVehicles.length > 0);

  const parseAmount = (val) => {
    const amount = parseFloat(val);
    return !isNaN(amount) && amount > 0;
  };

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between bg-blue-100 px-4 py-2 rounded shadow-xl cursor-pointer" onClick={onOpen}>
        <h2 className="text-lg font-semibold text-gray-800">Monthly Expenses</h2>
        {isOpen ? <ChevronRightIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Rent + Vehicle Insurance */}
          <div className="bg-white p-4 rounded shadow-xl border space-y-3">
            {!ownsHome && (
              <>
                <label className="text-sm font-medium">Do you pay rent?</label>
                <select name="paysRent" value={data.paysRent} onChange={onChange} className="input mb-2">
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {data.paysRent === "yes" && (
                  <input
                    name="rentAmount"
                    value={data.rentAmount}
                    onChange={onChange}
                    placeholder="Monthly Rent"
                    className="input"
                  />
                )}
              </>
            )}
            {ownsVehicle && (
              <input
                name="vehicleInsurance"
                value={data.vehicleInsurance}
                onChange={onChange}
                placeholder="Monthly Vehicle Insurance"
                className="input"
              />
            )}
          </div>

          {/* Child Support + Alimony */}
          <div className="bg-white p-4 rounded shadow-xl border space-y-3">
            <label className="text-sm font-medium">Child Support</label>
            <input
              name="childSupportAmount"
              value={data.childSupportAmount}
              onChange={onChange}
              placeholder="Monthly Child Support"
              className="input"
            />
            {parseAmount(data.childSupportAmount) && (
              <>
                <label className="text-sm mt-2">Is Child Support Deducted?</label>
                <select name="childSupportDeducted" value={data.childSupportDeducted} onChange={onChange} className="input">
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                <label className="text-sm">Behind on Payments?</label>
                <select name="childSupportArrearage" value={data.childSupportArrearage} onChange={onChange} className="input">
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {data.childSupportArrearage === 'yes' && (
                  <input
                    name="childSupportArrearageAmount"
                    value={data.childSupportArrearageAmount}
                    onChange={onChange}
                    placeholder="Arrearage Amount"
                    className="input"
                  />
                )}
              </>
            )}
            <input
              name="alimonyAmount"
              value={data.alimonyAmount}
              onChange={onChange}
              placeholder="Monthly Alimony"
              className="input"
            />
          </div>

          {/* Spouse Child Support + Alimony */}
          <div className="bg-white p-4 rounded shadow-xl border space-y-3">
            <label className="text-sm font-medium">Spouse Child Support</label>
            <input
              name="spouseChildSupportAmount"
              value={data.spouseChildSupportAmount}
              onChange={onChange}
              placeholder="Monthly Child Support"
              className="input"
            />
            {parseAmount(data.spouseChildSupportAmount) && (
              <>
                <label className="text-sm mt-2">Is Child Support Deducted?</label>
                <select name="spouseChildSupportDeducted" value={data.spouseChildSupportDeducted} onChange={onChange} className="input">
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                <label className="text-sm">Behind on Payments?</label>
                <select name="spouseChildSupportArrearage" value={data.spouseChildSupportArrearage} onChange={onChange} className="input">
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {data.spouseChildSupportArrearage === 'yes' && (
                  <input
                    name="spouseChildSupportArrearageAmount"
                    value={data.spouseChildSupportArrearageAmount}
                    onChange={onChange}
                    placeholder="Arrearage Amount"
                    className="input"
                  />
                )}
              </>
            )}
            <input
              name="spouseAlimonyAmount"
              value={data.spouseAlimonyAmount}
              onChange={onChange}
              placeholder="Monthly Alimony"
              className="input"
            />
          </div>
        </div>
      )}
    </section>
  );
}